// Search suggestion modal functionality
(function() {
  'use strict';
  
  let searchAbortController = null;
  let searchDebounceTimer = null;
  
  // Prevent form submission on Enter key
  document.addEventListener('keydown', function(event) {
    const searchInput = event.target.closest('.modal-component--search-suggestion-bar .predictive-search-input');
    if (!searchInput) return;

    if (event.key === 'Enter' || event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  });
  
  // Prevent form submission on submit event
  document.addEventListener('submit', function(event) {
    const form = event.target.closest('.modal-component--search-suggestion-bar form');
    if (form) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  });
  
  // Handle search input with suggest.json API
  document.addEventListener('input', function(event) {
    const searchInput = event.target.closest('.modal-component--search-suggestion-bar .predictive-search-input');
    if (!searchInput) {
      return;
    }
    const searchTerm = searchInput.value.trim();

    // Extract section ID from input ID (format: predictive-search-input-{sectionId})
    // The section ID might be like "sections--20481477443836__header" or just a number
    const inputIdParts = searchInput.id.split('predictive-search-input-');
    const sectionId = inputIdParts.length > 1 ? inputIdParts[1] : searchInput.id.split('-').pop();

    // Try multiple selector strategies to find containers
    const resultsContainer = document.querySelector('.modal-component--search-suggestion-bar .search-results-container');
    const topSuggestionsContainer = document.querySelector(`.modal-component--search-suggestion-bar #top-suggestions-menu-${sectionId}`) 
      || document.querySelector(`.modal-component--search-suggestion-bar [id*="top-suggestions-menu"]`);
    
    // Try to find results list with the section ID, or fallback to any predictive-search-list
    const resultsList = document.querySelector(`.modal-component--search-suggestion-bar #predictive-search-list-${sectionId}`)
      || document.querySelector(`.modal-component--search-suggestion-bar [id*="predictive-search-list"]`)
      || document.querySelector('.modal-component--search-suggestion-bar .search-results-list');
    
    const resultsHeading = document.querySelector(`.modal-component--search-suggestion-bar #search-results-heading-${sectionId}`)
      || document.querySelector(`.modal-component--search-suggestion-bar [id*="search-results-heading"]`);
    
    // Clear previous debounce timer
    if (searchDebounceTimer) {
      clearTimeout(searchDebounceTimer);
    }
    
    // Abort previous request
    if (searchAbortController) {
      searchAbortController.abort();
    }
    
    if (searchTerm.length === 0) {
      // Hide results, show top suggestions
      if (resultsContainer) resultsContainer.style.display = 'none';
      if (topSuggestionsContainer) topSuggestionsContainer.style.display = 'block';
      if (resultsList) resultsList.innerHTML = '';
      return;
    }
    
    // Debounce the search request
    searchDebounceTimer = setTimeout(() => {

      // Push search typing event into dataLayer for GTM / GA4
      if (searchTerm && searchTerm.length >= 3) {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'search_typing',
            search_term: searchTerm,
            search_source: 'header_search_modal'
          });
        } catch (trackingError) {
          if (window.console && console.error) {
            console.error('Search typing tracking error', trackingError);
          }
        }
      }
      
      // Show results container, hide top suggestions
      if (resultsContainer) {
        resultsContainer.style.display = 'block';
      }
      if (topSuggestionsContainer) {
        topSuggestionsContainer.style.display = 'none';
      }
      
      // Show loading state
      if (resultsList) {
        resultsList.innerHTML = '<div style="text-align: center; padding: 20px; color: #707071;">Loading...</div>';
      }
      
      // Create new abort controller
      searchAbortController = new AbortController();
      
      const suggestUrl = `/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=10`;
      
      // Fetch suggestions from Shopify suggest.json API
      fetch(suggestUrl, {
        signal: searchAbortController.signal
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Search request failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        if (resultsList) {
          resultsList.innerHTML = '';
        }
        
        if (resultsHeading) {
          const productCount = data.resources && data.resources.results && data.resources.results.products 
            ? data.resources.results.products.length 
            : 0;
          resultsHeading.textContent = `Search results (${productCount})`;
          resultsHeading.style.fontFamily = 'unset';
        }
        
        // Check if we have product results
        if (data.resources && data.resources.results && data.resources.results.products && data.resources.results.products.length > 0) {
          const products = data.resources.results.products;
          
          // Fetch full product data for each product to get variant info
          const productPromises = products.map((product, index) => {
            // Extract product handle from URL
            let productHandle = '';
            if (product.url) {
              const urlMatch = product.url.match(/\/products\/([^\/\?]+)/);
              productHandle = urlMatch ? urlMatch[1] : (product.handle || '');
            } else if (product.handle) {
              productHandle = product.handle;
            }
            
            if (!productHandle) {
              return Promise.resolve(null);
            }
            
            const productUrl = `/products/${productHandle}.js`;
            
            return fetch(productUrl)
              .then(response => {
                if (!response.ok) {
                  throw new Error(`Product not found: ${response.status}`);
                }
                return response.json();
              })
              .then(productData => {
                return productData;
              })
              .catch(err => {
                return null;
              });
          });
          
          Promise.all(productPromises).then(productDataArray => {
            
            // Filter out null products
            const validProducts = productDataArray.filter(p => p !== null);
            
            if (resultsList) {
              resultsList.innerHTML = '';
              
              // Check if we're on mobile (max-width: 991px)
              const isMobile = window.innerWidth <= 991;
              
              if (isMobile) {
                // Mobile: Create grid layout instead of carousel
                validProducts.forEach((productData, index) => {
                  if (!productData) {
                    return;
                  }
                  
                  const suggestProduct = products[index];
                  
                  const selectedVariant = productData.variants && productData.variants.length > 0 
                    ? productData.variants.find(v => v.available) || productData.variants[0]
                    : null;
                  
                  if (!selectedVariant) {
                    return;
                  }
                  
                  // Get product image
                  let imageUrl = '';
                  let hoverImageUrl = '';
                  
                  if (productData.images && productData.images.length > 0) {
                    const firstImage = productData.images[0];
                    // Handle both full URLs and relative paths
                    if (firstImage.indexOf('http') === 0) {
                      imageUrl = firstImage.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_500x.$1');
                    } else {
                      imageUrl = firstImage.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_500x.$1');
                      if (imageUrl.indexOf('//') !== 0 && imageUrl.indexOf('http') !== 0) {
                        imageUrl = 'https:' + imageUrl;
                      }
                    }
                    
                    // Get hover image (last image if multiple)
                    if (productData.images.length > 1) {
                      const lastImage = productData.images[productData.images.length - 1];
                      if (lastImage.indexOf('http') === 0) {
                        hoverImageUrl = lastImage.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_500x.$1');
                      } else {
                        hoverImageUrl = lastImage.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_500x.$1');
                        if (hoverImageUrl.indexOf('//') !== 0 && hoverImageUrl.indexOf('http') !== 0) {
                          hoverImageUrl = 'https:' + hoverImageUrl;
                        }
                      }
                    }
                  } else if (suggestProduct.image) {
                    // Fallback to suggest product image
                    imageUrl = suggestProduct.image;
                  }
                  
                  // Create product card HTML (directly in grid, no swiper-slide wrapper)
                  const productCardWrapper = document.createElement('div');
                  productCardWrapper.className = 'Details_with_products_innerright_innerboxs_maininfo_new';
                  
                  // Simplified card: image + title linking to product page
                  productCardWrapper.innerHTML = `
                    <div class="Details_with_products_innerright_innerboxs_innerinfo_new">
                      <div class="grid__item grid-product">
                        <div class="grid-product__content">
                          <div class="grid__item-image-wrapper">
                            <a href="${productData.url}" class="grid_product_link_new" aria-label="${(productData.title || '').replace(/"/g, '&quot;')}">
                              <div class="product-card-image-container">
                                <div class="product-card-image product-card-image--first">
                                  <img src="${imageUrl}" alt="${productData.title || ''}" loading="lazy" style="width: 100%; height: 100%; object-fit: cover;">
                                </div>
                                ${hoverImageUrl ? `<div class="product-card-image product-card-image--last">
                                  <img src="${hoverImageUrl}" alt="${productData.title || ''}" loading="lazy" style="width: 100%; height: 100%; object-fit: cover;">
                                </div>` : ''}
                              </div>
                            </a>
                          </div>
                          <div class="grid-product__meta">
                            <p class="product-title">
                              <a class="product-title-link" href="${productData.url}" aria-label="${(productData.title || '').replace(/"/g, '&quot;')}"><span class="product-title-link-text">${productData.title || ''}</span><span class="--loader search-modal-product-link_loader" aria-hidden="true"><svg class="ico ico-loader" viewBox="0 0 135 140" width="14" height="14"><use href="#icn-loader"></use></svg></span></a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  `;
                  
                  resultsList.appendChild(productCardWrapper);
                });
                
                // Add grid class to results list for mobile
                resultsList.classList.add('search-results-grid-mobile');
              } else {
                // Desktop: Create Swiper wrapper structure
                const swiperWrapper = document.createElement('div');
                swiperWrapper.className = 'swiper search-results-swiper';
                swiperWrapper.innerHTML = `
                  <div class="swiper-wrapper"></div>
                  <div class="swiper-button-next search-results-swiper-next"></div>
                  <div class="swiper-button-prev search-results-swiper-prev"></div>
                `;
                
                const swiperSlidesContainer = swiperWrapper.querySelector('.swiper-wrapper');
                
                validProducts.forEach((productData, index) => {
                  if (!productData) {
                    return;
                  }
                  
                  const suggestProduct = products[index];
                  
                  const selectedVariant = productData.variants && productData.variants.length > 0 
                    ? productData.variants.find(v => v.available) || productData.variants[0]
                    : null;
                  
                  if (!selectedVariant) {
                    return;
                  }
                  
                  // Get product image
                  let imageUrl = '';
                  let hoverImageUrl = '';
                  
                  if (productData.images && productData.images.length > 0) {
                    const firstImage = productData.images[0];
                    // Handle both full URLs and relative paths
                    if (firstImage.indexOf('http') === 0) {
                      imageUrl = firstImage.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_500x.$1');
                    } else {
                      imageUrl = firstImage.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_500x.$1');
                      if (imageUrl.indexOf('//') !== 0 && imageUrl.indexOf('http') !== 0) {
                        imageUrl = 'https:' + imageUrl;
                      }
                    }
                    
                    // Get hover image (last image if multiple)
                    if (productData.images.length > 1) {
                      const lastImage = productData.images[productData.images.length - 1];
                      if (lastImage.indexOf('http') === 0) {
                        hoverImageUrl = lastImage.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_500x.$1');
                      } else {
                        hoverImageUrl = lastImage.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_500x.$1');
                        if (hoverImageUrl.indexOf('//') !== 0 && hoverImageUrl.indexOf('http') !== 0) {
                          hoverImageUrl = 'https:' + hoverImageUrl;
                        }
                      }
                    }
                  } else if (suggestProduct.image) {
                    // Fallback to suggest product image
                    imageUrl = suggestProduct.image;
                  }
                  
                  // Create product card HTML
                  const slide = document.createElement('div');
                  slide.className = 'swiper-slide';
                  
                  const productCardWrapper = document.createElement('div');
                  productCardWrapper.className = 'Details_with_products_innerright_innerboxs_maininfo_new';
                  
                  // Simplified card: image + title linking to product page
                  productCardWrapper.innerHTML = `
                    <div class="Details_with_products_innerright_innerboxs_innerinfo_new">
                      <div class="grid__item grid-product">
                        <div class="grid-product__content">
                          <div class="grid__item-image-wrapper">
                            <a href="${productData.url}" class="grid_product_link_new" aria-label="${(productData.title || '').replace(/"/g, '&quot;')}">
                              <div class="product-card-image-container">
                                <div class="product-card-image product-card-image--first">
                                  <img src="${imageUrl}" alt="${productData.title || ''}" loading="lazy" style="width: 100%; height: 100%; object-fit: cover;">
                                </div>
                                ${hoverImageUrl ? `<div class="product-card-image product-card-image--last">
                                  <img src="${hoverImageUrl}" alt="${productData.title || ''}" loading="lazy" style="width: 100%; height: 100%; object-fit: cover;">
                                </div>` : ''}
                              </div>
                            </a>
                          </div>
                          <div class="grid-product__meta">
                            <p class="product-title">
                              <a class="product-title-link" href="${productData.url}" aria-label="${(productData.title || '').replace(/"/g, '&quot;')}"><span class="product-title-link-text">${productData.title || ''}</span><span class="--loader search-modal-product-link_loader" aria-hidden="true"><svg class="ico ico-loader" viewBox="0 0 135 140" width="14" height="14"><use href="#icn-loader"></use></svg></span></a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  `;
                  
                  slide.appendChild(productCardWrapper);
                  swiperSlidesContainer.appendChild(slide);
                });
                
                // Append Swiper to results list
                resultsList.appendChild(swiperWrapper);
                
                // Initialize Swiper carousel
                if (typeof Swiper !== 'undefined') {
                  // Destroy existing Swiper instance if any
                  if (swiperWrapper.swiper) {
                    swiperWrapper.swiper.destroy(true, true);
                  }
                  
                  const swiper = new Swiper(swiperWrapper, {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    loop: false,
                    navigation: {
                      nextEl: swiperWrapper.querySelector('.search-results-swiper-next'),
                      prevEl: swiperWrapper.querySelector('.search-results-swiper-prev'),
                    },
                    breakpoints: {
                      320: {
                        slidesPerView: 2,
                        spaceBetween: 12
                      },
                      768: {
                        slidesPerView: 2,
                        spaceBetween: 16
                      },
                      992: {
                        slidesPerView: 4,
                        spaceBetween: 20
                      },
                      1400: {
                        slidesPerView: 4,
                        spaceBetween: 20
                      }
                    }
                  });
                }
              }
            }
          }).catch(err => {
          });
        } else {
          // No results
          if (resultsList) {
            resultsList.innerHTML = '<div style="text-align: center; padding: 20px; color: #707071;">No products found</div>';
          }
        }
      })
      .catch(error => {
        if (error.name === 'AbortError') {
          // Request was aborted, ignore
          return;
        }
        if (resultsList) {
          resultsList.innerHTML = '<div style="text-align: center; padding: 20px; color: #d32f2f;">Error loading search results</div>';
        }
      });
    }, 300); // 300ms debounce
  });
  
  // Helper function to format money (if not available globally)
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.money_format || '${{amount}}');
    }
    // Fallback formatting
    return '$' + (cents / 100).toFixed(2);
  }
})();

// Handle close button - clear search input and close modal
// Use capture phase to intercept before modal-component-toggler handles it
document.addEventListener('click', function(event) {
  // Check if the click is on the close button or its children (SVG, etc.)
  const closeBtn = event.target.closest('.modal-component--search-suggestion-bar .close-search');
  if (closeBtn) {
    
    // Clear search input first
    const searchInput = closeBtn.closest('.modal-component--search-suggestion-bar').querySelector('.predictive-search-input');
    if (searchInput) {
      searchInput.value = '';
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
    
    // Allow the modal-component-toggler to handle closing the modal
    // Don't prevent default or stop propagation - let it close normally
    // The modal-component-toggler will handle the close via data-modal-ref
  }
}, true); // Use capture phase to run before other handlers

// Navigation menu links: show loader next to text when redirecting
document.addEventListener('click', function(event) {
  const link = event.target.closest('.modal-component--search-suggestion-bar .search-menu-link');
  if (!link) return;
  event.preventDefault();
  link.classList.add('--show-loader');
  window.location.href = link.getAttribute('href') || link.href;
});

// Top Suggestions products (search_id_div): push search_suggestion_click when a product is clicked
document.addEventListener('click', function(event) {
  var link = event.target.closest('.modal-component--search-suggestion-bar .search_id_div .product-title-link');
  if (!link) {
    link = event.target.closest('.modal-component--search-suggestion-bar .search_id_div .grid_product_link_new');
  }
  if (!link) return;
  var href = link.getAttribute('href') || link.href;
  var titleSpan = link.querySelector && link.querySelector('.product-title-link-text');
  var label = titleSpan ? titleSpan.textContent.trim() : '';
  if (!label && link.classList && link.classList.contains('grid_product_link_new')) {
    var card = link.closest('.Details_with_products_innerright_innerboxs_maininfo_new') || link.closest('.grid-product__content');
    var titleLink = card ? card.querySelector('.product-title-link') : null;
    titleSpan = titleLink ? titleLink.querySelector('.product-title-link-text') : null;
    label = titleSpan ? titleSpan.textContent.trim() : '';
  }
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'search_suggestion_click',
      suggestion_label: label,
      suggestion_url: href,
      search_source: 'header_search_modal'
    });
  } catch (trackingError) {
    if (window.console && console.error) {
      console.error('Search suggestion tracking error', trackingError);
    }
  }
});

// Search result product title links: show loader next to title when redirecting
document.addEventListener('click', function(event) {
  const link = event.target.closest('.modal-component--search-suggestion-bar .product-title-link');
  if (!link) return;
  var href = link.getAttribute('href') || link.href;

  // Push search result click event into dataLayer
  try {
    var titleSpan = link.querySelector('.product-title-link-text');
    var itemName = titleSpan ? titleSpan.textContent.trim() : '';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'search_result_click',
      item_name: itemName,
      item_url: href,
      search_source: 'header_search_modal'
    });
  } catch (trackingError) {
    if (window.console && console.error) {
      console.error('Search result title tracking error', trackingError);
    }
  }

  event.preventDefault();
  link.classList.add('--show-loader');
  window.location.href = href;
});

// Product image links: show loader on the same card's title link when redirecting
document.addEventListener('click', function(event) {
  const link = event.target.closest('.modal-component--search-suggestion-bar .grid_product_link_new');
  if (!link) return;
  const card = link.closest('.Details_with_products_innerright_innerboxs_maininfo_new') || link.closest('.grid-product__content');
  const titleLink = card ? card.querySelector('.product-title-link') : null;
  var href = link.getAttribute('href') || link.href;

  // Push search result click event into dataLayer for image clicks
  try {
    var titleSpan = titleLink ? titleLink.querySelector('.product-title-link-text') : null;
    var itemName = titleSpan ? titleSpan.textContent.trim() : '';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'search_result_click',
      item_name: itemName,
      item_url: href,
      search_source: 'header_search_modal'
    });
  } catch (trackingError) {
    if (window.console && console.error) {
      console.error('Search result image tracking error', trackingError);
    }
  }

  event.preventDefault();
  if (titleLink) titleLink.classList.add('--show-loader');
  window.location.href = href;
});

// Handle custom add to cart buttons (for search modal product cards)
// Use event delegation to handle dynamically added buttons
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-custom-add-to-cart="true"]');
  if (!button) return;
  
  // Only handle buttons within the search suggestion modal
  const searchModal = button.closest('.modal-component--search-suggestion-bar');
  if (!searchModal) return;
  
  event.preventDefault();
  event.stopPropagation();
  
  const variantId = button.getAttribute('data-variant-id');
  if (!variantId) {
    return;
  }
  
  // Get the modal component to close it later
  const modalComponent = searchModal.closest('modal-component');
  const modalId = modalComponent ? modalComponent.getAttribute('data-modal') : null;
  
  // Show loading state: add class and update label
  const buttonTextEl = button.querySelector('.new-carousel__button-text');
  const originalText = buttonTextEl ? buttonTextEl.textContent.trim() : 'Add to cart';
  button.disabled = true;
  button.classList.add('--show-loader');
  if (buttonTextEl) buttonTextEl.textContent = 'Adding...';
  
  // Add to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1
      }]
    })
  })
  .then(response => {
    if (!response.ok) {
      return response.json().then(err => Promise.reject(err));
    }
    return response.json();
  })
  .then(data => {
    // Re-enable button and clear loading state
    button.disabled = false;
    button.classList.remove('--show-loader');
    const btnText = button.querySelector('.new-carousel__button-text');
    if (btnText) btnText.textContent = originalText;
    
    // Close the search modal immediately
    if (modalComponent && typeof modalComponent.close === 'function') {
      modalComponent.close();
    } else if (modalId) {
      // Fallback: find and close the modal using the modal ID
      const modalToClose = document.querySelector(`modal-component[data-modal="${modalId}"]`);
      if (modalToClose && typeof modalToClose.close === 'function') {
        modalToClose.close();
      }
    }
    
    // Update cart drawer if it exists
    const cartDrawer = document.querySelector('[data-modal="modal-cart-drawer"]');
    if (cartDrawer) {
      // Reload cart drawer content
      fetch(window.location.href)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCartDrawer = doc.querySelector('[data-modal="modal-cart-drawer"]');
          if (newCartDrawer) {
            cartDrawer.innerHTML = newCartDrawer.innerHTML;
            // Notify any drawer-dependent scripts (e.g. xsell positioning) that
            // the drawer DOM has been replaced.
            document.dispatchEvent(new CustomEvent('cart:drawer:updated'));
          }
        })
        .catch(err => {});
    }
    
    // Update cart count if cart inventory organizer exists
    const cartOrganizer = document.querySelector('cart-inventory-organizer');
    if (cartOrganizer && cartOrganizer.updateBubbleStatus) {
      cartOrganizer.updateBubbleStatus();
    }
    
    // Try to open cart drawer
    const cartDrawerModal = document.querySelector('modal-component[data-modal="modal-cart-drawer"]');
    if (cartDrawerModal) {
      cartDrawerModal.open();
      // Re-run positioning after the drawer is actually opened.
      setTimeout(() => document.dispatchEvent(new CustomEvent('cart:drawer:updated')), 200);
    }
  })
  .catch(error => {
    button.disabled = false;
    button.classList.remove('--show-loader');
    const btnText = button.querySelector('.new-carousel__button-text');
    if (btnText) btnText.textContent = originalText;
    
    // Show error message if possible
    const errorContainer = button.closest('.grid-product__content')?.querySelector('.product-card_error-message');
    if (errorContainer) {
      errorContainer.textContent = error.description || error.message || 'Failed to add product to cart';
      errorContainer.classList.remove('hidden');
      setTimeout(() => {
        errorContainer.classList.add('hidden');
      }, 5000);
    } else {
      alert(error.description || error.message || 'Failed to add product to cart');
    }
  });
});

// Autofocus the search input when opening the search modal (desktop only)
document.addEventListener('click', function(event) {
  // Header search buttons/toggles use data-modal-ref="modal-search-bar-{{ section.id }}"
  const searchToggle = event.target.closest('[data-modal-ref^="modal-search-bar-"]');
  if (!searchToggle) return;

  // Only apply on desktop
  if (window.innerWidth < 992) {
    return;
  }

  // Wait briefly for the modal to open, then focus the input
  setTimeout(function() {
    const activeModal =
      document.querySelector('modal-component.modal--active .modal-component--search-suggestion-bar') ||
      document.querySelector('.modal-component--search-suggestion-bar');

    if (!activeModal) return;

    const input = activeModal.querySelector('.predictive-search-input');
    if (input) {
      input.focus();
      input.select();
    }
  }, 200);
});

